@if (activeTab === 'system') {
  <table id="systemAccountsSectionTable" class="table table-responsive" aria-describedby="System User Accounts">
    <thead>
      <tr>
        <th scope="col" class="name-table-header sortable" style="width: 20vw" (click)="sortUserAccounts('firstName')">
          First Name
          @if (sortProperty === 'firstName') {
            <span>
              @if (!sortAscending) {
                <span class="fas fa-arrow-down"></span>
              }
              @if (sortAscending) {
                <span class="fas fa-arrow-up"></span>
              }
            </span>
          }
        </th>
        <th scope="col" class="name-table-header sortable" style="width: 20vw" (click)="sortUserAccounts('lastName')">
          Last Name
          @if (sortProperty === 'lastName') {
            <span>
              @if (!sortAscending) {
                <span class="fas fa-arrow-down"></span>
              }
              @if (sortAscending) {
                <span class="fas fa-arrow-up"></span>
              }
            </span>
          }
        </th>
        <th scope="col" class="name-table-header sortable" style="width: 30vw" (click)="sortUserAccounts('email')">
          Email Address
          @if (sortProperty === 'email') {
            <span>
              @if (!sortAscending) {
                <span class="fas fa-arrow-down"></span>
              }
              @if (sortAscending) {
                <span class="fas fa-arrow-up"></span>
              }
            </span>
          }
        </th>
        <th scope="col" class="name-table-header" style="width: 20vw">
          System Account Type
        </th>
        <th scope="col" class="name-table-header" style="width: 10vw">
          Action
        </th>
      </tr>
    </thead>
    <tbody>
      @for (systemUserAccount of userList; track systemUserAccount) {
        <tr>
          <td>{{ systemUserAccount.firstName }}</td>
          <td>{{ systemUserAccount.lastName }}</td>
          <td>{{ systemUserAccount.email }}</td>
          @for (systemAccount of systemUserAccount.systemAccounts; track systemAccount) {
            <td>
              {{ systemAccount.accountType }}
            </td>
          }
          <td>
            @for (systemAccount of systemUserAccount.systemAccounts; track systemAccount) {
              <div>
                <button type="button" class="btn-secondary action-btn pt-2 reset-btn" (click)="deleteConfirmationDialog(systemAccount, systemUserAccount.firstName)">
                  <i class="fas fa-trash-alt action-icon cursor-hand"></i> Delete
                </button>
              </div>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
}
